import { render } from "./FileInputButton.vue?vue&type=template&id=a39ae332&ts=true"
import script from "./FileInputButton.vue?vue&type=script&lang=ts"
export * from "./FileInputButton.vue?vue&type=script&lang=ts"

import "./FileInputButton.vue?vue&type=style&index=0&id=a39ae332&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__